import React from 'react'

export const GenericErrorImage = () => (
  <svg
    height="100%"
    width="auto"
    viewBox="0 0 202 234"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>ErrorMsg_Illustration Copy 2</title>
    <defs>
      <radialGradient
        cx="35.0337114%"
        cy="50.0000227%"
        fx="35.0337114%"
        fy="50.0000227%"
        r="142.373573%"
        gradientTransform="translate(0.350337,0.500000),scale(0.353691,1.000000),rotate(35.098312),translate(-0.350337,-0.500000)"
        id="radialGradient-1"
      >
        <stop stopColor="#EAE7E7" offset="0%" />
        <stop stopColor="#D8D8D8" offset="100%" />
      </radialGradient>
      <radialGradient
        cx="18.2051713%"
        cy="99.5573108%"
        fx="18.2051713%"
        fy="99.5573108%"
        r="215.679915%"
        gradientTransform="translate(0.182052,0.995573),scale(1.000000,0.362043),rotate(-79.326375),translate(-0.182052,-0.995573)"
        id="radialGradient-2"
      >
        <stop stopColor="#525252" offset="0%" />
        <stop stopColor="#2A333D" offset="100%" />
      </radialGradient>
      <linearGradient
        x1="81.0785636%"
        y1="7.3295973%"
        x2="46.3912363%"
        y2="38.6248496%"
        id="linearGradient-3"
      >
        <stop stopColor="#C4D8EA" offset="0%" />
        <stop stopColor="#91AFD1" offset="100%" />
      </linearGradient>
      <radialGradient
        cx="90.0554909%"
        cy="99.9999898%"
        fx="90.0554909%"
        fy="99.9999898%"
        r="217.189643%"
        gradientTransform="translate(0.900555,1.000000),scale(1.000000,0.713905),rotate(-122.457878),translate(-0.900555,-1.000000)"
        id="radialGradient-4"
      >
        <stop stopColor="#F8E8B4" offset="0%" />
        <stop stopColor="#E4AF00" offset="100%" />
      </radialGradient>
      <linearGradient
        x1="50.6793375%"
        y1="70.9042756%"
        x2="50.5688851%"
        y2="115.720799%"
        id="linearGradient-5"
      >
        <stop stopColor="#ECCB5E" offset="0%" />
        <stop stopColor="#EFD682" offset="100%" />
      </linearGradient>
      <radialGradient
        cx="33.8491009%"
        cy="2.53958276e-06%"
        fx="33.8491009%"
        fy="2.53958276e-06%"
        r="142.477048%"
        gradientTransform="translate(0.338491,0.000000),scale(0.356168,1.000000),rotate(44.577021),translate(-0.338491,-0.000000)"
        id="radialGradient-6"
      >
        <stop stopColor="#DFDEDE" offset="0%" />
        <stop stopColor="#D8D8D8" offset="100%" />
      </radialGradient>
      <radialGradient
        cx="87.5089383%"
        cy="22.067893%"
        fx="87.5089383%"
        fy="22.067893%"
        r="66.6160855%"
        gradientTransform="translate(0.875089,0.220679),scale(0.764961,1.000000),rotate(157.238994),translate(-0.875089,-0.220679)"
        id="radialGradient-7"
      >
        <stop stopColor="#656B71" offset="0%" />
        <stop stopColor="#44505F" offset="100%" />
      </radialGradient>
      <radialGradient
        cx="29.0054246%"
        cy="3.02657541e-05%"
        fx="29.0054246%"
        fy="3.02657541e-05%"
        r="127.063081%"
        gradientTransform="translate(0.290054,0.000000),scale(1.000000,0.827946),rotate(56.031659),translate(-0.290054,-0.000000)"
        id="radialGradient-8"
      >
        <stop stopColor="#44505F" offset="0%" />
        <stop stopColor="#2A333D" offset="100%" />
      </radialGradient>
      <radialGradient
        cx="83.5983963%"
        cy="26.7574265%"
        fx="83.5983963%"
        fy="26.7574265%"
        r="93.418901%"
        gradientTransform="translate(0.835984,0.267574),scale(0.551018,1.000000),rotate(147.640924),translate(-0.835984,-0.267574)"
        id="radialGradient-9"
      >
        <stop stopColor="#5045D6" offset="0%" />
        <stop stopColor="#4438D3" offset="100%" />
      </radialGradient>
      <radialGradient
        cx="22.942821%"
        cy="16.975506%"
        fx="22.942821%"
        fy="16.975506%"
        r="87.9869129%"
        gradientTransform="translate(0.229428,0.169755),scale(0.928805,1.000000),rotate(70.665330),translate(-0.229428,-0.169755)"
        id="radialGradient-10"
      >
        <stop stopColor="#7165E4" offset="0%" />
        <stop stopColor="#4E3FDE" offset="100%" />
      </radialGradient>
    </defs>
    <g
      id="Playground"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="00-00-01-Search-start-Copy-8"
        transform="translate(-619.000000, -402.000000)"
        fillRule="nonzero"
      >
        <g
          id="ErrorMsg_Illustration-Copy-2"
          transform="translate(619.000000, 402.002843)"
        >
          <g
            id="Left-[shoe]"
            transform="translate(127.016853, 175.146479) rotate(38.000000) translate(-127.016853, -175.146479) translate(111.965702, 169.823021)"
            fill="url(#radialGradient-1)"
          >
            <path
              d="M0.87838908,3.11005265 C0.29279636,4.65778476 -3.87557122e-16,5.81502441 -3.87557122e-16,6.5817716 C-3.87557122e-16,7.51036483 0.155916535,8.86541331 0.467749607,10.646917 C1.55347661,10.646917 11.3110879,10.646917 29.7405837,10.646917 C30.5012809,8.15175469 30.0621623,6.80469686 28.4232281,6.60574349 C26.7842938,6.40679012 25.4228033,6.22715116 24.3387565,6.0668266 L10.7213627,0.0436158673 C10.4643634,-0.070059391 10.1638723,0.0461276777 10.050197,0.303126948 C10.0486427,0.306641147 10.0471281,0.31017284 10.0456537,0.31372135 L9.16729953,2.4277227 L9.16729953,2.4277227 C7.65007507,3.1300856 6.41717267,3.48126706 5.46859235,3.48126706 C4.69355688,3.48126706 3.62156483,3.16895643 2.25261618,2.54433518 L2.25260978,2.54434922 C1.74129445,2.31104725 1.13766286,2.5364216 0.904360882,3.04773693 C0.895016791,3.06821587 0.886354757,3.08899922 0.87838908,3.11005265 Z"
              id="shoe"
            />
          </g>
          <path
            d="M127.230329,174.071792 C126.393207,158.048438 126.305081,146.55335 126.965951,139.586528 C128.097523,127.657638 129.459476,117.299126 130.250211,113.537229 C132.135821,104.566505 144.572938,108.696319 144.554331,113.501232 C144.52607,120.773659 140.932533,141.131089 133.773697,174.573523 L127.230329,174.071792 Z"
            id="LegLower"
            fill="#B28B67"
            transform="translate(135.541474, 141.408738) rotate(20.000000) translate(-135.541474, -141.408738) "
          />
          <path
            d="M126.22031,166.048336 L129.006378,113.721286 C130.94185,104.669546 147.118846,108.827489 147.099949,113.675752 C147.056935,124.68281 140.308888,162.722796 140.296083,166.002166 L126.22031,166.048336 Z"
            id="LegLower"
            fill="url(#radialGradient-2)"
            transform="translate(136.660130, 137.212454) rotate(20.000000) translate(-136.660130, -137.212454) "
          />
          <g
            id="undraw_stranded_traveler_pdbw-copy-5"
            transform="translate(0.000000, 124.997157)"
          >
            <path
              d="M101,109 C127.93108,109 161.597747,109 202,109 C171.853839,102.601677 138.187173,99.4025156 101,99.4025156 C63.8128268,99.4025156 30.1461602,102.601677 0,109 C48.3494108,109 82.0160777,109 101,109 Z"
              id="Oval"
              fill="#E4F0FE"
            />
            <ellipse
              id="Oval"
              fill="#A5C2E3"
              cx="72.5395188"
              cy="97.0031445"
              rx="5.20618557"
              ry="5.14150944"
            />
            <ellipse
              id="Oval-Copy"
              fill="#A5C2E3"
              cx="127.378007"
              cy="97.0031445"
              rx="5.20618557"
              ry="5.14150944"
            />
            <path
              d="M77.7457044,96.9728469 C77.7457044,94.1500029 75.5702084,91.8616354 72.8865979,91.8616354 C70.2029875,91.8616354 68.0274913,94.1500029 68.0274913,96.9728469 C68.0274913,97.6738694 70.3720026,98.0229348 72.757912,98.031293 C75.2295941,98.0399513 77.7457044,97.6829664 77.7457044,96.9728469 Z"
              id="Oval"
              fill="#91AFD1"
            />
            <path
              d="M131.890034,96.9728469 C131.890034,94.1500029 129.714538,91.8616354 127.030928,91.8616354 C124.347317,91.8616354 122.171821,94.1500029 122.171821,96.9728469 C122.171821,97.6738694 124.516333,98.0229348 126.902242,98.031293 C129.373924,98.0399513 131.890034,97.6829664 131.890034,96.9728469 Z"
              id="Oval-Copy-2"
              fill="#91AFD1"
            />
            <path
              d="M70.7352627,100.480803 C70.6130465,100.273333 69.7624804,99.4533571 69.7624804,97.3673514 C69.7624804,95.2813457 70.7352627,93.0701873 70.7352627,93.2421303 C70.7352627,93.5431466 68.0274913,93.8509587 68.0274913,96.8680315 C68.0274913,99.8851036 71.3164674,101.467431 70.7352627,100.480803 Z"
              id="Oval"
              fill="#87A5C6"
            />
            <path
              d="M124.879593,100.480803 C124.757376,100.273333 123.906811,99.4533571 123.906811,97.3673514 C123.906811,95.2813457 124.879593,93.0701873 124.879593,93.2421303 C124.879593,93.5431466 122.171821,93.8509587 122.171821,96.8680315 C122.171821,99.8851036 125.460797,101.467431 124.879593,100.480803 Z"
              id="Oval-Copy-3"
              fill="#87A5C6"
            />
            <path
              d="M135.993033,29.4779874 C133.343033,29.4785916 131.054084,31.3031668 130.501718,33.8552428 L138.332705,33.8552428 L138.332705,53.2073113 L130.501718,53.2073113 C131.100195,55.9746783 133.723929,57.8505401 136.581571,57.5541572 C139.439214,57.2577743 141.608454,54.8848053 141.608248,52.0553881 L141.608248,35.0071472 C141.608248,33.5407209 141.016651,32.1343546 139.963593,31.097435 C138.910535,30.0605155 137.482281,29.4779874 135.993033,29.4779874 L135.993033,29.4779874 Z"
              id="Path"
              fill="url(#linearGradient-3)"
            />
            <path
              d="M76.5561151,0 C71.0817226,0.00617867157 66.6454042,4.40663553 66.6391752,9.83677497 L66.6391752,85.4525382 C66.6454068,90.8826754 71.0817245,95.2831293 76.5561151,95.2893082 L124.749731,95.2893082 C130.224122,95.2831293 134.660437,90.8826746 134.666667,85.4525382 L134.666667,9.83677497 C134.660437,4.40663734 130.224122,0.00618123473 124.749731,0 L76.5561151,0 Z"
              id="Path"
              fill="url(#radialGradient-4)"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="82.6048108"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <rect
              id="Rectangle-Copy"
              fill="url(#linearGradient-5)"
              x="75.6632302"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="90.2405499"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="98.5704464"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="106.206186"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="113.841925"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
            <path
              d="M66.7307997,57.5849057 C82.6096174,57.6212008 96.1883251,55.3534242 107.466923,50.7811366 C118.745522,46.2088489 127.812103,39.1900053 134.666667,29.7246057 L132.584192,0 L72.8865979,0 L67.3333333,8.25622093 L66.7307997,57.5849057 Z"
              id="Path-11"
              fillOpacity="0.0563538024"
              fill="#C59800"
            />
            <rect
              id="Rectangle"
              fill="url(#linearGradient-5)"
              x="122.171821"
              y="3.42767296"
              width="2.7766323"
              height="87.7484279"
              rx="1.38831615"
            />
          </g>
          <g id="Group-2-Copy" transform="translate(67.000000, 0.000000)">
            <g id="Group-16" transform="translate(8.849154, 102.803147)">
              <path
                d="M69.9508311,80.8260722 C69.432952,74.2916025 68.4707968,51.6706284 69.4334722,41.2002176 C70.5323615,29.248294 71.8650808,18.8707366 72.6445322,15.1026708 C74.5032343,6.11723443 86.9227671,10.2873773 86.9163027,15.1026708 C86.9016101,26.0348776 76.9088595,77.5583289 76.3871248,80.8153988 C75.86539,84.072468 70.276302,84.9327832 69.9508311,80.8260722 Z"
                id="Legs-[skin]"
                fill="#B28B67"
              />
              <g
                id="Right-[shoe]"
                transform="translate(65.403164, 72.097877)"
                fill="url(#radialGradient-6)"
              >
                <path
                  d="M1.74641426,6.81344702 C1.16302129,8.36633722 0.871551455,9.52743871 0.872004218,10.2967515 C0.872558732,11.2280645 1.02881089,12.5871742 1.3407612,14.3740803 C2.42321343,14.3747224 12.1513939,14.3804936 30.5253026,14.3913939 C31.2822238,11.8893732 30.8436299,10.5381102 29.2095209,10.3376047 C27.5754118,10.1370992 26.2179212,9.95612883 25.1370489,9.79469354 L11.5571189,3.7457723 C11.3005979,3.63150991 11.0011702,3.74767543 10.8883283,4.00523524 C10.8868509,4.00860742 10.88541,4.01199572 10.8840057,4.01539956 L10.0091913,6.13595748 L10.0091913,6.13595748 C8.4969601,6.83948023 7.26798492,7.19096108 6.3222657,7.19040004 C5.54955636,7.18994163 4.48059181,6.87607284 3.11537205,6.24879367 L3.11537864,6.2487791 C2.60499028,6.01427034 2.00345446,6.23957233 1.77181078,6.75200516 C1.76268162,6.77220034 1.7542116,6.79269188 1.74641426,6.81344702 Z"
                  id="shoe"
                  transform="translate(15.878366, 9.046603) rotate(15.000000) translate(-15.878366, -9.046603) "
                />
              </g>
              <path
                d="M88.3495745,18.8189413 C88.3495745,32.5417177 81.8221747,64.5515556 81.8180443,67.5731926 L67.7740177,67.5839629 C69.8296281,39.0219003 70.5585322,24.5870202 69.9607298,24.2793229 C69.0640263,23.8177768 33.2019416,27.8541765 22.446319,27.8541765 C6.93665787,27.8541765 0.520621659,18.0892679 0,0 L30.7240616,0 C36.9797564,0.668327817 69.6100343,7.23937347 81.728272,9.49826255 C86.9162978,10.4653316 88.3495745,15.0386697 88.3495745,18.8189413 Z"
                id="Leg-and-Butt"
                fill="url(#radialGradient-7)"
              />
            </g>
            <g
              id="Head"
              transform="translate(31.431859, 35.996507) rotate(7.000000) translate(-31.431859, -35.996507) translate(20.739132, 17.147425)"
              fill="#B28B67"
            >
              <path
                d="M19.4217316,4.71688357 C22.3723189,10.2947255 22.0217124,24.4433841 18.2083412,25.4403 C16.687593,25.8378637 13.4479685,24.8640089 10.1507663,22.8484192 L12.2202602,37.6981639 L6.99529285e-17,37.6981639 L4.20677476,17.8109315 C1.86063473,15.0178224 0.272740327,11.5948591 0.538086743,7.75934279 C1.30264421,-3.2921448 16.4711442,-0.860958342 19.4217316,4.71688357 Z"
                id="Head-[skin]"
              />
            </g>
            <path
              d="M38.2026062,14.3585932 C36.5030594,13.8356959 34.036081,13.657822 32.9983523,13.7773753 C33.5882708,12.3516699 33.8220663,10.7631412 33.6306526,9.21630761 C33.4446069,7.71327228 32.7780647,6.43333539 32.1615683,5.09213972 C31.8773948,4.47393629 31.5553773,3.85909096 31.0753954,3.38616028 C30.5864457,2.90434136 29.9675844,2.58621711 29.318701,2.43434294 C28.6546627,2.27888489 27.9603648,2.29161399 27.2953799,2.43233029 C27.0012062,2.49457179 26.7372819,2.63009709 26.4487847,2.70539498 C26.1533458,2.78254381 26.0099653,2.59607225 25.7954565,2.4086538 C25.2785085,1.95706336 24.5207902,1.73398844 23.8669291,1.65404036 C23.1333287,1.56438359 22.3721757,1.67572012 21.672628,1.91863263 C20.9917233,2.15510733 20.3376379,2.53923487 19.8454559,3.09897436 C19.6263117,3.34813104 19.427409,3.63174125 19.298175,3.94489207 C19.2451733,4.07340307 19.236428,4.14953929 19.1092203,4.19658414 C18.991572,4.24013642 18.8539577,4.24136028 18.7325402,4.28280587 C17.558507,4.68337632 16.5548839,5.59767946 16.0086094,6.7718194 C15.6898998,7.45680806 15.5391825,8.66294876 15.5809454,10.0148948 C15.6227083,11.366841 16.8346009,14.8947706 17.9675037,16.1817899 C18.9787393,17.3305623 20.4648697,18.0888809 21.8989899,18.4210519 C20.9474659,19.5175893 20.3142516,20.8879889 19.8461104,22.281766 C19.3376196,23.7957617 19.0230917,25.3689385 18.9072388,26.9719035 C18.7971945,28.4948992 18.787421,30.105517 19.1420203,31.5961355 C19.473742,32.9901002 20.1826126,34.1337743 21.3656561,34.8595376 C21.907562,35.1919999 22.4905819,35.441808 23.0769674,35.6701398 C23.6548628,35.8951424 24.2345018,36.1139129 24.8398205,36.2402546 C25.9854349,36.479275 27.3053578,36.4386789 28.1875106,35.5197085 C28.5054488,35.1884194 28.8550985,34.7721151 29.0870115,34.3673577 C29.1703954,34.2218 29.2206696,34.126599 29.1192724,33.9842729 C28.9977942,33.8138103 28.8013514,33.6831641 28.6453313,33.5497923 C27.7555967,32.7893709 27.2046887,31.7743946 27.0655384,30.5683474 C26.92436,29.3446547 27.2499541,27.7653327 28.4298996,27.2316475 C29.8864271,26.5728423 31.4908923,27.3299737 32.7858387,28.0356816 C33.3355384,26.0779622 34.4648703,24.3154304 36.2359906,23.4178556 C38.1954359,22.4248666 40.444167,22.3092406 42.4578418,21.4573428 C42.9825705,21.2353519 43.5170098,20.9833379 43.9032644,20.5308277 C44.0646665,20.3417062 44.2540197,20.0963732 44.3184115,19.8462036 C44.4030125,19.5175847 44.1926834,19.2419847 44.0302017,18.9857279 C43.1686597,17.6269853 39.9021529,14.8814904 38.2026062,14.3585932 Z"
              id="hair"
              fill="url(#radialGradient-8)"
              transform="translate(29.955947, 18.993713) rotate(7.000000) translate(-29.955947, -18.993713) "
            />
            <path
              d="M51.0241464,52.5437064 L70.0282903,59.8197084 C74.6598854,59.7935029 78.6535424,60.2463735 82.0092604,61.1783201 C82.8577006,61.6117691 84.0158302,62.6433015 81.1142773,63.2064553 C78.2127248,63.7696092 75.184155,64.4919201 75.0439419,65.5647791 C74.9037288,66.6376382 76.9268878,67.3193605 76.4738692,68.8393405 C76.171857,69.8526605 73.1038126,68.3617014 67.2697364,64.3664633 L49.764043,62.1855557 L51.0241464,52.5437064 Z"
              id="Hand"
              fill="#B28B67"
              transform="translate(66.366884, 60.845283) rotate(-34.000000) translate(-66.366884, -60.845283) "
            />
            <path
              d="M79.3577552,47.3982381 L84.809932,47.4025658 C86.1559656,47.403634 87.2504857,48.501077 87.2546108,49.8537733 C87.2546162,49.8557253 87.2546199,49.8576771 87.2546213,49.859629 L87.2652159,65.6601453 C87.2661208,67.010549 86.1792224,68.1026953 84.835464,68.1016296 L79.3832872,68.0973019 C78.0372534,68.0962338 76.9427335,66.9987907 76.9386084,65.6460944 C76.9386025,65.6441425 76.9385988,65.6421906 76.9385975,65.6402387 L76.928003,49.8397224 C76.9270981,48.4893187 78.0139963,47.3971725 79.3577552,47.3982381 Z"
              id="Rectangle"
              fill="#BFDAF9"
              transform="translate(82.096609, 57.749934) rotate(19.000000) translate(-82.096609, -57.749934) "
            />
            <path
              d="M78.9399435,48.8066153 L85.1814733,48.811836 C85.7423214,48.8123051 86.1983516,49.2695924 86.2000465,49.8332159 C86.2000489,49.8340267 86.2000504,49.8348375 86.2000512,49.8356483 L86.2098018,65.1817965 C86.2101595,65.7444675 85.7572648,66.1995136 85.1973622,66.1990456 L78.9558316,66.193825 C78.3949844,66.1933559 77.9389537,65.7360686 77.9372588,65.1724451 C77.9372563,65.1716343 77.9372549,65.1708234 77.9372544,65.1700127 L77.9275034,49.8238644 C77.9271461,49.2611933 78.3800409,48.8061474 78.9399435,48.8066153 Z"
              id="Rectangle"
              fill="#A1BCDB"
              transform="translate(82.068653, 57.502830) rotate(19.000000) translate(-82.068653, -57.502830) "
            />
            <path
              d="M80.0371504,47.3130613 L85.0546289,47.3170441 C85.9944561,47.3177899 86.7586709,48.0840457 86.7615587,49.0285242 C86.7623671,49.2961887 86.7006518,49.5600665 86.5813713,49.7989254 L79.4123171,64.1548872 C79.1611459,64.6578544 78.5510152,64.8593956 78.0495514,64.6050422 C77.7057777,64.4306727 77.4887277,64.0765246 77.4888276,63.6901411 L77.4924015,49.8677032 C77.4927669,48.4543261 78.6307235,47.311946 80.0371504,47.3130613 Z"
              id="Rectangle"
              fillOpacity="0.231424825"
              fill="#E4F0FE"
              transform="translate(82.125193, 56.014076) rotate(19.000000) translate(-82.125193, -56.014076) "
            />
            <path
              d="M51.5737556,54.341397 L70.5778996,61.617399 C75.2094946,61.5911935 75.7337642,66.2896106 75.5935511,67.3624697 C75.4533381,68.4353288 77.476497,69.117051 77.0234785,70.637031 C76.7214662,71.650351 73.6534219,70.159392 67.8193457,66.1641539 L50.3136523,63.9832463 L51.5737556,54.341397 Z"
              id="Hand"
              fill="#B28B67"
              transform="translate(63.701699, 62.642973) rotate(-34.000000) translate(-63.701699, -62.642973) "
            />
            <path
              d="M69.8714276,73.5549285 L77.6919973,69.1911724 C78.7919757,64.9547768 80.1047293,62.8227483 81.6302566,62.7950869 C82.8025668,62.2408808 80.8509727,66.3957078 82.9797005,67.1286875 C83.7365287,67.3892843 84.9492007,67.1770882 85.955242,66.6248571 C87.8902472,65.5627042 89.6876159,63.424894 90.3993048,62.6287974 C91.6111987,61.2731714 91.7065593,68.4005776 90.2530691,70.2793009 C87.5364989,73.7906325 85.2885388,74.9923653 79.733373,76.5679491 C76.8288457,77.3917456 73.6879847,79.0410169 70.3107905,81.5157624 L69.8714276,73.5549285 Z"
              id="Hand"
              fill="#B28B67"
              transform="translate(80.598612, 71.987148) rotate(-19.000000) translate(-80.598612, -71.987148) "
            />
            <path
              d="M33.813639,61.0776271 C40.0289234,62.0193568 48.5102795,62.0224668 58.2244616,57.718262 L60.470006,66.201152 C53.4252654,71.4008351 44.0778145,75.0942948 36.6238029,73.661586 C30.749631,72.5325324 28.8617018,64.732624 33.813639,61.0776271 Z"
              id="Sleeve"
              fill="url(#radialGradient-9)"
              transform="translate(45.720648, 65.845430) rotate(9.000000) translate(-45.720648, -65.845430) "
            />
            <path
              d="M33.5869433,42.9295924 C34.2840887,51.9084952 37.4713439,61.6991608 40.4499652,71.4889935 L40.4310845,71.4836846 C46.8923482,73.4521079 58.4071064,71.8214115 74.9753591,66.5915954 C78.8501741,73.702582 80.6414042,78.7721701 80.3490494,81.8003595 C66.6399533,88.1527289 54.9351066,90.904016 45.3499704,90.9698471 C46.5805905,98.7871118 46.4175173,106.229105 43.320687,112.830421 C38.6007913,122.89152 10.9631795,113.57382 1.67056739,115.407771 C-1.93740288,103.661299 1.01676262,96.2379336 3.78507699,89.4031869 L4.05217169,88.7434719 C5.64854066,84.7947024 7.10886062,81.00377 7.11211983,76.6395958 C7.12203422,63.3639412 17.7553193,42.9295924 19.3197941,42.9295924 L19.3197941,42.9295924 L33.5869433,42.9295924 Z"
              id="Clothes"
              fill="url(#radialGradient-10)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
